import React from 'react';
import PropTypes from 'prop-types';
import SelectorBase from './SelectorBase';
import i18nMessages from '../../../constants/messages/pt-BR';

const Checkbox = props => {
  const { className, ...other } = props;

  return (
    <SelectorBase
      type={i18nMessages.checkbox}
      className={className}
      {...other}
    />
  );
};

Checkbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,

  className: PropTypes.string,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string.isRequired,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: PropTypes.bool,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: PropTypes.oneOfType([PropTypes.object]),
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: PropTypes.func,

  onChange: PropTypes.func.isRequired,
  /**
   * The input component property `type`.
   */
  type: PropTypes.string,
  /**
   * The value of the component.
   */
  value: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Checkbox = ({prop = val, className = '', disabled = false, indeterminate = false, inputProps = { }) =>
Checkbox.defaultProps = {
  className: '',
  disabled: false,
  indeterminate: false,
  inputProps: {},
  inputRef: () => null,
  type: 'checkbox',
  value: '',
};

export default Checkbox;
